/** Mirrors leazepro-backend validators/mobile.go and the app's MobileValidator: the web must reject exactly what the server would. */
const RULES: Record<string, { pattern: RegExp; length?: number }> = {
  '91': { pattern: /^[6-9][0-9]{9}$/, length: 10 },
  '92': { pattern: /^3[0-9]{9}$/, length: 10 },
  '880': { pattern: /^1[3-9][0-9]{8}$/, length: 10 },
  '977': { pattern: /^9[6-8][0-9]{8}$/, length: 10 },
  '94': { pattern: /^7[0-9]{8}$/, length: 9 },
  '971': { pattern: /^5[0-9]{8}$/, length: 9 },
  '966': { pattern: /^5[0-9]{8}$/, length: 9 },
  '974': { pattern: /^[3567][0-9]{7}$/, length: 8 },
  '973': { pattern: /^[369][0-9]{7}$/, length: 8 },
  '965': { pattern: /^[569][0-9]{7}$/, length: 8 },
  '1': { pattern: /^[2-9][0-9]{9}$/, length: 10 },
  '44': { pattern: /^7[0-9]{9}$/, length: 10 },
  '49': { pattern: /^1[5-7][0-9]{8,9}$/ },
  '33': { pattern: /^[67][0-9]{8}$/, length: 9 },
  '39': { pattern: /^3[0-9]{9}$/, length: 10 },
  '34': { pattern: /^[67][0-9]{8}$/, length: 9 },
  '31': { pattern: /^6[0-9]{8}$/, length: 9 },
  '41': { pattern: /^7[5-9][0-9]{7}$/, length: 9 },
  '61': { pattern: /^4[0-9]{8}$/, length: 9 },
  '64': { pattern: /^2[0-9]{7,9}$/ },
  '65': { pattern: /^[89][0-9]{7}$/, length: 8 },
  '60': { pattern: /^1[0-9]{8,9}$/ },
  '66': { pattern: /^[689][0-9]{8}$/, length: 9 },
  '84': { pattern: /^[35789][0-9]{8}$/, length: 9 },
  '63': { pattern: /^9[0-9]{9}$/, length: 10 },
  '86': { pattern: /^1[3-9][0-9]{9}$/, length: 11 },
  '81': { pattern: /^[789]0[0-9]{8}$/, length: 10 },
  '82': { pattern: /^1[0-9]{9}$/, length: 10 },
}
const FALLBACK = /^[0-9]{6,12}$/

export const DEFAULT_COUNTRY_CODE = '91'

export function isValidCountryCode(cc: string): boolean {
  return /^[0-9]{1,3}$/.test(cc)
}

/** The one demo account's number, signed in to behind any dialling code (LP-1025): the server moves the account to the country picked. */
export const DEMO_LOCAL_NUMBER = '8888888888'

/** Exactly the demo number. Sign-in only: everywhere else (a tenant's mobile) it is checked like any number, and most countries reject it. */
export function isDemoNumber(number: string): boolean {
  return number === DEMO_LOCAL_NUMBER
}

export function isValidMobile(cc: string, number: string): boolean {
  if (!isValidCountryCode(cc)) return false
  return (RULES[cc]?.pattern ?? FALLBACK).test(number)
}

/** Fixed digit count for the counter, when the country has one. */
export function mobileLength(cc: string): number | undefined {
  return RULES[cc]?.length
}

/** What the API expects: "<cc> <number>". */
export const formatMobile = (cc: string, number: string) => `${cc} ${number}`

/** "+91 98 ****** 40" — first two and last two digits; empty below six digits. */
export function maskMobile(cc: string, number: string): string {
  if (number.length < 6) return ''
  return `+${cc} ${number.slice(0, 2)} ${'*'.repeat(number.length - 4)} ${number.slice(-2)}`
}

export const NAME_VALID = (v: string) => v.trim().length > 0 && !/\s/.test(v.trim())
export const EMAIL_VALID = (v: string) => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v.trim())
